/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { ToggleDelta } from '@customerio/fly-components/addon/components/fly-grouped-checklist';
import IntegrationsSegmentOutModel from 'cio/models/integrations/segment-out';
import AnalyticsService from 'cio/services/analytics';
import { SEGMENT_OUT_META } from 'cio/utils/integrations/segment-out';
import { DATA_OUT_EVENTS } from 'cio/utils/base-events';

interface IntegrationsSegmentOutFormArgs {
  integration: IntegrationsSegmentOutModel;
  isNewIntegration: boolean;
}

export default class IntegrationsSegmentOutForm extends Component<IntegrationsSegmentOutFormArgs> {
  @service analytics!: AnalyticsService;

  readonly groups = DATA_OUT_EVENTS;

  get cannotEnableIntegration() {
    return !this.args.integration.enabled && this.args.integration.events?.length === 0;
  }

  @action
  setEnabled(value: boolean) {
    this.args.integration.set('enabled', value);
  }

  @action
  setSelectedEvents({ selectedItems }: ToggleDelta) {
    this.args.integration.set('events', selectedItems);
  }

  @action
  setResolution(value: boolean) {
    this.args.integration.set('resolution', value);
  }

  @action
  setEU(value: boolean) {
    this.args.integration.set('eu', value);
  }

  @action
  toggleEnabled() {
    // toggle
    this.args.integration.set('enabled', !this.args.integration.enabled);

    // track
    if (this.args.integration.enabled) {
      this.analytics.track('integration', 'enable_started', {
        ...SEGMENT_OUT_META,
        enabledOrReenabled: this.args.isNewIntegration ? 'Enabled' : 'Re-Enabled',
      });
    } else {
      this.analytics.track('integration', 'disable_started', {
        ...SEGMENT_OUT_META,
        disabledOrDeleted: 'Disabled',
      });
    }
  }
}
